import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  buildQuestionnaireApiService,
  type BuildQuestionnaireRequest,
} from "@/generated/fastapi";

export async function buildQuestionnaire(
  accessToken: string | null | undefined,
  request: BuildQuestionnaireRequest,
) {
  const response = await buildQuestionnaireApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(
      `Failed to get thoughts to reflect (${response.status})`,
    );
  }

  return response.data ?? null;
}
